export default __webpack_public_path__ + "static/media/category-icon-Product.efe0cbe8.svg";